import type { LayoutLoad } from './$types';
import { createSearchPOIsFromAddressStore, createSearchPoisStore } from '$routes/(map)/loadPois';

export const load = (async () => {
	const searchPOIStore = createSearchPoisStore();
	const searchPOIFromAddressStore = createSearchPOIsFromAddressStore();

	return {
		searchPOIStore,
		searchPOIFromAddressStore,
	};
}) satisfies LayoutLoad;
